module.exports = __webpack_public_path__ + "media/components/country-flag/static/sl-8d496d62105a2e4eabd4e196ee824a83.svg";